//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction, CollapseAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { ContactsFilter, ContactsOrder, ICAMSContact, ContactsCustomFilterFields, ContactListConfig } from './ContactsModels';
import { CustomFilter, CustomFilterOperator } from '../Models/CustomFilterModels';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';

export class Contacts {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private contactsCountFromServer: number;
    private currentPage: number = 0;
    private actionBtns: any;
    private currentSortOrder: ContactsOrder = ContactsOrder.ListName;
    private currentSortDirection: OrderDirection;
    private openContactsListPanel_Config: ContactListConfig;
    private openContactsListPanel_Callback: Function;

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
        
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openContactsListPanel = (loadData: boolean, contactsListConfig: ContactListConfig, callback: Function): void => {
        const self = this;
        self.openContactsListPanel_Config = contactsListConfig;
        self.openContactsListPanel_Callback = callback;

        // Wait for the contacts modal to be closed, then unblock the UI
        let eventContactsModalClosedUnsubscribe = events.bus.subscribe(events.eventContactsModalClosed, e => {
            eventContactsModalClosedUnsubscribe();
            eventContactSelectedUnsubscribe();
            if (callback!= null) callback(null);
        });

        let eventContactSelectedUnsubscribe = events.bus.subscribe(events.eventContactSelected, e => {
            eventContactsModalClosedUnsubscribe();
            eventContactSelectedUnsubscribe();
            let contact: Array<ICAMSContact> = e.payload;
            if (callback != null) callback(contact);
        });

        Utilities.BlockUI();
        $('#placeholder-for-contactsmodals').load(window.G_SITEFOLDERNAME +'/Contacts/ContactsListView', { search: ""}, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Create the modal
            Utilities.GetModal('#contactsListModal', ModalAction.Create);

            // Predefined filter, only add in filters if this value is not true
            if (contactsListConfig.RestrictToContactsWithAccounts != true) {
                $('#contactsListPredefinedFilter').append($("<option></option>").attr("value", ContactsFilter.All).text("All"));
                $('#contactsListPredefinedFilter').append($("<option></option>").attr("value", ContactsFilter.StatusAwaitingAuthentication).text("Status - awaiting authentication"));
                $('#contactsListPredefinedFilter').append($("<option></option>").attr("value", ContactsFilter.StatusLocked).text("Status - locked"));
                $('#contactsListPredefinedFilter').append($("<option></option>").attr("value", ContactsFilter.StatusInactive).text("Status - inactive (no login in last year)"));
                $('#contactsListPredefinedFilter').append($("<option></option>").attr("value", ContactsFilter.NewAccountCreated).text("New account - created in last month"));
                $('#contactsListPredefinedFilter').on('change', function () {
                    self.resetPage();
                    self.GetContactsData();
                });
            }
            // Allways add this filter
            $('#contactsListPredefinedFilter').append($("<option></option>").attr("value", ContactsFilter.ContactsWithAccounts).text("Contacts with accounts"));
            

            // Filters
            $('#contactsListClearFilterBtn').on('click', function () { self.clearFilters(); });
            $('#contactsListApplyFilterBtn').on('click', function () {
                self.resetPage();
                Utilities.GetCollapse('#contactsListFilterContainer', CollapseAction.Hide);

                self.GetContactsData();
            });
            ($('#contactsListFilterContainer [name="ContactType"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });

            // Paging
            $('#contactsListShowingStartBtn').on("click", function () {
                self.currentPage = 0;
                this.blur();
                self.GetContactsData();
            });
            $('#contactsListShowingEndBtn').on("click", function () {
                let maxNumberInList = $('#contactsListPageAmount select').children("option:selected").val() as number;
                self.currentPage = Math.trunc(self.contactsCountFromServer / maxNumberInList);
                this.blur();
                self.GetContactsData();
            });
            $('#contactsListShowingNextBtn').on("click", function () {
                let maxNumberInList = $('#contactsListPageAmount select').children("option:selected").val() as number;
                if (self.currentPage == Math.trunc(self.contactsCountFromServer / maxNumberInList)) return;
                self.currentPage++;
                this.blur();
                self.GetContactsData();
            });
            $('#contactsListShowingPrevBtn').on("click", function () {
                if (self.currentPage == 0) return;
                self.currentPage--;
                this.blur();
                self.GetContactsData();
            });
            $('#contactsListPageAmount select').on('change', function () { self.resetPage(); self.GetContactsData(); });

            $('#contactsListCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsListModal', ModalAction.Hide);
                events.bus.publish(events.eventContactsModalClosed(null));
            });

            // Get table action buttons
            self.getActionBtnRefs();
            self.actionBtns.add.btn.on('click', function () {
                Utilities.GetModal('#contactsListModal', ModalAction.Hide);
                events.bus.publish(events.eventOpenContactsCreatePanel());
            });
            self.actionBtns.account.btn.on('click', function () {
                var table: any = $('#contactsListResultsTable')
                let rows = table.bootstrapTable('getSelections');
                if (rows == null || rows.length != 1) {
                    toastr.error('You must select a single contact.');
                    return;
                }

                Utilities.GetModal('#contactsListModal', ModalAction.Hide);
                let data: ICAMSKey = { code: rows[0].ContactRef, featureType: FeatureType.Contact };
                events.bus.publish(events.eventOpenContactsAccountPanel(data));
            });
            self.actionBtns.edit.btn.on('click', function () {
                var table: any = $('#contactsListResultsTable')
                let rows = table.bootstrapTable('getSelections');
                if (rows == null || rows.length != 1) {
                    toastr.error('You must select a single contact.');
                    return;
                }

                Utilities.GetModal('#contactsListModal', ModalAction.Hide);
                let data: ICAMSKey = { code: rows[0].ContactRef, featureType: FeatureType.Contact };
                events.bus.publish(events.eventOpenContactsEditPanel([data, true, null]));
            });
            self.actionBtns.use.btn.on('click', function () {
                var table: any = $('#contactsListResultsTable')
                let rows: Array<any> = table.bootstrapTable('getSelections');

                let contactList: Array<ICAMSContact> = [];
                rows.forEach(function (r) {
                    contactList.push({ ContactRef: r.ContactRef, ListName: r.ListName, ContactType: r.ContactType });
                });
                Utilities.GetModal('#contactsListModal', ModalAction.Hide);
                events.bus.publish(events.eventContactSelected(contactList));
                events.bus.publish(events.eventContactsModalClosed(null));
            });
            self.actionBtns.viewprint.btn.on('click', function () { toastr.info('To be completed'); this.blur(); });
            self.actionBtns.query.btn.on('click', function () {
                Utilities.GetModal('#contactsListModal', ModalAction.Hide);
                var table: any = $('#contactsListResultsTable')
                let rows = table.bootstrapTable('getSelections');
                let data: Array<ICAMSKey> = [];
                rows.forEach(r => data.push({ code: r.ContactRef, featureType: FeatureType.Contact }));
                events.bus.publish(events.eventOpenNotificationQueryPanel([data[0], null]));
            });
            self.actionBtns.export.btn.on('click', function () { toastr.info('To be completed'); this.blur(); });

            // Check the btns
            self.checkVisibleButtons();

            // Initialize table
            var table: any = $('#contactsListResultsTable')
            table.bootstrapTable();

            //table.on('click-cell.bs.table', function (e, field, value, row, $element) {
            //    $('#contactsListModal').modal('hide');
            //    let data: ICAMSKey = { code: row.ContactRef, featureType: FeatureType.Contact };
            //    events.bus.publish(events.eventOpenContactsEditPanel(data));
            //});

            table.on('check.bs.table', function (e, row, $element) {
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            });
            table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            });
            table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            });
            table.on('sort.bs.table', function (e, name, order) {
                e.preventDefault();
                switch (name) {
                    case "ContactRef":
                        self.currentSortOrder = ContactsOrder.ContactRef;
                        break;
                    case "ListName":
                        self.currentSortOrder = ContactsOrder.ListName;
                        break;
                    case "Address":
                        self.currentSortOrder = ContactsOrder.Address;
                        break;
                    case "Tel1":
                        self.currentSortOrder = ContactsOrder.Tel1;
                        break;
                    case "Email":
                        self.currentSortOrder = ContactsOrder.Email;
                        break;
                    default:
                        self.currentSortOrder = null;
                        break;
                }

                switch (order) {
                    case "asc":
                        self.currentSortDirection = OrderDirection.ASC;
                        break;
                    case "desc":
                        self.currentSortDirection = OrderDirection.DESC;
                        break;
                }
                
                self.GetContactsData();
            });
            self.updateNumberCheckedMessage();

            // Load data
            if (loadData == true) {
                self.GetContactsData();
            }
        });
    }

    public openCreatePanel = (): void => {
        const self = this;

        Utilities.BlockUI();
        Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
        $('#placeholder-for-contactsmodals2').load(window.G_SITEFOLDERNAME +'/Contacts/ContactCreate', function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal('#contactsCreateModal', ModalAction.Create);

            //$('[name="Title"]').on('change', function () { self.updateListName(); });
            //$('[name="FirstName"]').on('change', function () { self.updateListName(); });
            //$('[name="Surname"]').on('change', function () { self.updateListName(); });

            ($('#contactsCreateModal [name="ContactTypeVals"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });

            $('#contactsCreateModal_suggestListName').on('click', function () {
                var listName = self.suggestListName(
                    $('#contactsCreateModal [name="Surname"]').val().toString(),
                    $('#contactsCreateModal [name="FirstName"]').val().toString(),
                    $('#contactsCreateModal [name="Initials"]').val().toString(),
                    $('#contactsCreateModal [name="Company"]').val().toString(),
                    $('#contactsCreateModal [name="Town"]').val().toString()
                );
                $('#contactsCreateModal [name="ListName"]').val(listName);
                toastr.info("Suggested listname shown");
            });

            // Get form validation
            Utilities.InitFormValidation($("#contactsCreateModal"));

            $('#contactsCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Auto fill listname if it is not filled in
                if ($('#contactsCreateModal [name="ListName"]').val() == "") {
                    var listName = self.suggestListName(
                        $('#contactsCreateModal [name="Surname"]').val().toString(),
                        $('#contactsCreateModal [name="FirstName"]').val().toString(),
                        $('#contactsCreateModal [name="Initials"]').val().toString(),
                        $('#contactsCreateModal [name="Company"]').val().toString(),
                        $('#contactsCreateModal [name="Town"]').val().toString()
                    );
                    $('#contactsCreateModal [name="ListName"]').val(listName);
                }

                // Validate
                let form: any = $('#contactsCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                let formData = new FormData(<any>$('#contactsCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Contacts/CreateContact',
                    data: formData,
                    success: function (result: IAPIResult) {
                        Utilities.UnBlockUI();
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#contactsCreateModal', ModalAction.Hide);
                                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                                Utilities.GetModal('#contactsListModal', ModalAction.Show);
                                self.GetContactsData();
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            }
                            else {
                                let msg: string = 'Failed to create contact!';
                                if (result.data) msg = result.data;
                                toastr.error(msg);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    },
                    error: function (err) {
                        console.log(err);
                        Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#contactsCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsCreateModal', ModalAction.Hide);
                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                Utilities.GetModal('#contactsListModal', ModalAction.Show);
                self.GetContactsData();
            });

            $('#contactsCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsCreateModal', ModalAction.Hide);
                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                Utilities.GetModal('#contactsListModal', ModalAction.Show);
                self.GetContactsData();
            });
        });
    }

    public openEditPanel = (data: ICAMSKey, reopenContactListOnFormClose: Boolean, callback: Function): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
        $('#placeholder-for-contactsmodals2').load(window.G_SITEFOLDERNAME +'/Contacts/ContactEdit', { contactRef: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal('#contactsEditModal', ModalAction.Create);

            //$('[name="Title"]').on('change', function () { self.updateListName(); });
            //$('[name="FirstName"]').on('change', function () { self.updateListName(); });
            //$('[name="Surname"]').on('change', function () { self.updateListName(); });
            $('#contactsGotoAccountBtn').on('click', function () {
                Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
                events.bus.publish(events.eventOpenContactsAccountPanel(data));
            });

            ($('#contactsEditModal [name="ContactTypeVals"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });

            $('#contactsEditModal_suggestListName').on('click', function () {
                var listName = self.suggestListName(
                    $('#contactsEditForm [name="Surname"]').val().toString(),
                    $('#contactsEditForm [name="FirstName"]').val().toString(),
                    $('#contactsEditForm [name="Initials"]').val().toString(),
                    $('#contactsEditForm [name="Company"]').val().toString(),
                    $('#contactsEditForm [name="Town"]').val().toString()
                );
                $('#contactsEditForm [name="ListName"]').val(listName);
                toastr.info("Suggested listname shown");
            });

            // Create Tables
            ($('#contactsEditModal_IssuesTable') as any).bootstrapTable();

            var table: any = Utilities.GetControl('#contactsEditModal_IssuesTable');
            table.bootstrapTable();

            //$('#contactsEditModal_IssuesTable [data-issueref]').on('click', function () {
            table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                if (field == "code") {                   
                    var linkdata: ICAMSKey = $element.find("[data-issueref]").data("issueref");
                    events.bus.publish(events.eventOpenMaintEditPanel(linkdata));
                    Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
                }                
            });
            // Get form validation
            Utilities.InitFormValidation($("#contactsEditModal"));

            $('#contactsEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#contactsEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;
                
                Utilities.BlockUI();
                let formData = new FormData(<any>$('#contactsEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Contacts/UpdateContact',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                UserDefinedFields.SaveUDFFieldsAtServer($('#contactsEditForm'), '/Contacts/UpdateContactUserFields');

                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
                                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                                if (reopenContactListOnFormClose == true) {
                                    Utilities.GetModal('#contactsListModal', ModalAction.Show);
                                    self.GetContactsData();
                                }
                                if (callback) callback($('#contactsEditForm [name="ListName"]').val());
                            }
                            else {
                                let msg: string = 'Failed to edit contact!';
                                if (result.data) msg = result.data;
                                toastr.error(msg);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#contactsEditDeleteBtn').on('click', function (evt) {
                let cloudscribeID = $('#contactsEditModal [name="ContactRef"]').val() as string;
                self.deleteContact(cloudscribeID);
            });

            $('#contactsEditCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                if (reopenContactListOnFormClose == true) {
                    Utilities.GetModal('#contactsListModal', ModalAction.Show);
                    self.GetContactsData();
                }

                if (callback) callback();
            });

            $('#contactsEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                if (reopenContactListOnFormClose == true) {
                    Utilities.GetModal('#contactsListModal', ModalAction.Show);
                    self.GetContactsData();
                }
                if (callback) callback();
            });
        });
    }

    public openAccountPanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
        $('#placeholder-for-contactsmodals2').load(window.G_SITEFOLDERNAME +'/Contacts/ContactAccount', { contactRef: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal('#contactsAccountModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#contactsAccountModal"));

            $('#contactsAccountCreateBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsAccountModal', ModalAction.Hide);
                events.bus.publish(events.eventOpenContactsEditPanel([data, true, null]));
            });

            $('#contactsAccountCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsAccountModal', ModalAction.Hide);
                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                Utilities.GetModal('#contactsListModal', ModalAction.Show);
                self.GetContactsData();
            });

            $('#contactsAccountCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#contactsAccountModal', ModalAction.Hide);
                //events.bus.publish(events.eventOpenContactsListView([true, self.openContactsListPanel_Config, self.openContactsListPanel_Callback]));
                Utilities.GetModal('#contactsListModal', ModalAction.Show);
                self.GetContactsData();
            });

            $('#contactsEditAccountBtn').on('click', function () {
                window.location.href = 'useradmin';
            });

            $('#contactsEditDeleteBtn').on('click', function () {
                let cloudscribeID = $('[name="CloudscribeID"]').val() as string;
                self.deleteAccount(cloudscribeID, $('#contactsAccountModal'));
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetContactsData = (): void => {
        const self = this;

        let filterVal = $('#contactsListPredefinedFilter').children("option:selected").val() as ContactsFilter;
        let maxNumberInList = $('#contactsListPageAmount select').children("option:selected").val() as number;

        // Custom filters
        var customFilters: Array<CustomFilter> = self.getCustomFilters();

        // Construct query
        let query = { data: { Filter: filterVal, CustomFilters: customFilters, Order: self.currentSortOrder, OrderDirection: self.currentSortDirection, Skip: self.currentPage * maxNumberInList, Take: maxNumberInList } };

        // get the issue count
        self.getCount(query);

        Utilities.BlockUI($('#contactsListResults'));
        $.post('/Contacts/GetFilteredContacts', query,
            function (result: IAPIResult) {
                try {
                    if (result != null) {
                        var data = JSON.parse(result.data);
                        var table: any = $('#contactsListResultsTable')
                        table.bootstrapTable('load', data)
                        self.updatePagingUI();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI($('#contactsListResults'));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private getCount = (query: any): void => {
        // Get the data from the server
        const self = this;
        
        $.post('/Contacts/GetFilteredContactsCount', query, function (response) {
            try {
                self.contactsCountFromServer = JSON.parse(response);
                if (self.contactsCountFromServer > 0) {
                    $('#contactsListResultsCount').html(' (' + self.contactsCountFromServer + ')');
                }
                else {
                    $('#contactsListResultsCount').html();
                }
            }
            catch (e) {
                console.log("Error getting issue data: getCount");
                console.log(e);
            }
        }).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // FILTERS
    private clearFilters = (): void => {
        $('#contactsListFilterContainer [name="FirstName"]').val(null);
        $('#contactsListFilterContainer [name="Surname"]').val(null);
        $('#contactsListFilterContainer [name="Company"]').val(null);
        $('#contactsListFilterContainer [name="Town"]').val(null);
        $('#contactsListFilterContainer [name="Postcode"]').val(null);
        $('#contactsListFilterContainer [name="Tel"]').val(null);
        $('#contactsListFilterContainer [name="Email"]').val(null);
        $('#contactsListFilterContainer [name="ListName"]').val(null);
        $('#contactsListFilterContainer [name="ContactRef"]').val(null);
        
        ($('#contactsListFilterContainer [name="ContactType"]') as any).multiselect('deselectAll');
    }

    private getCustomFilters = (): Array<CustomFilter> => {
        var customFilters: CustomFilter[] = [];
        let searchValue: string; 

        if ($('#contactsListFilterContainer [name="FirstName"]').val() == null) return customFilters;

        searchValue = $('#contactsListFilterContainer [name="FirstName"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "FirstName"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="Surname"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "Surname"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="Company"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "Company"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="Town"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "Town"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="Postcode"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "Postcode"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="Tel"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "Tel"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="Email"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "Email"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="ListName"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "ListName"), operator: CustomFilterOperator.Contains, searchValue: searchValue });

        searchValue = $('#contactsListFilterContainer [name="ContactRef"]').val().toString();
        if (searchValue != null && searchValue != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "ContactRef"), operator: CustomFilterOperator.Contains, searchValue: searchValue });
        
        let contactTypeVal = $('#contactsListFilterContainer [name="ContactType"]').val().toString(); 
        if (contactTypeVal != null && contactTypeVal != "") customFilters.push({ field: ContactsCustomFilterFields.Fields.find(f => f.fieldName == "ContactType"), operator: CustomFilterOperator.Or, searchValue: contactTypeVal });

        return customFilters;
    }

    // ----------------------------------------------------------- //
    // TABLE
    private checkVisibleButtons = (): void => {
        const self = this;
        var table: any = $('#contactsListResultsTable')
        let rows = table.bootstrapTable('getSelections');

        if (this.actionBtns == null) return;

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].config.visible == false) self.actionBtns[k].btn.parent().hide();
            else self.actionBtns[k].btn.parent().show();
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionBtns.add.enable = true;
        if (rows && rows.length == 1) {
            self.actionBtns.account.enable = true;
            self.actionBtns.edit.enable = true;
            self.actionBtns.use.enable = true;
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.query.enable = true;
            self.actionBtns.export.enable = true;
        }
        else if (rows && rows.length > 1) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.query.enable = true;
            self.actionBtns.export.enable = true;

            if (self.openContactsListPanel_Config.AllowMultipleSelection == true) self.actionBtns.use.enable = true;
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    private updateNumberCheckedMessage = (): void => {
        var table: any = $('#contactsListResultsTable')
        let num = table.bootstrapTable('getSelections').length;
        let s = num > 1 ? "s" : "";
        if (num == 0) {
            $('#contactsListNumberCheckedBtn').hide();
        }
        else {
            $('#contactsListNumberCheckedBtn').html(`${num} item${s} selected`);
            $('#contactsListNumberCheckedBtn').show();
        }
    }

    private getActionBtnRefs = (): void => {
        const self = this;
        self.actionBtns = {
            viewprint: { btn: $('#contactsListPrintBtn button'), enable: false, config: self.openContactsListPanel_Config.ActionBtns.viewprint },
            account: { btn: $('#contactsListAccountBtn button'), enable: false, config: self.openContactsListPanel_Config.ActionBtns.account },
            add: { btn: $('#contactsListAddBtn button'), enable: false, config: self.openContactsListPanel_Config.ActionBtns.add },
            edit: { btn: $('#contactsListEditBtn button'), enable: false, config: self.openContactsListPanel_Config.ActionBtns.edit },
            query: { btn: $('#contactsListQueryBtn button'), enable: false, config: self.openContactsListPanel_Config.ActionBtns.query },
            use: { btn: $('#contactsListUseBtn button'), enable: false, config: self.openContactsListPanel_Config.ActionBtns.use },
            export: { btn: $('#contactsListExportBtn button'), enable: false, config: self.openContactsListPanel_Config.ActionBtns.export }
        };
    }

    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        self.checkVisibleButtons();
        if (self.contactsCountFromServer > 0) {
            $('#contactsListResultsCount').html(' (' + self.contactsCountFromServer + ')');
        }
        else {
            $('#contactsListResultsCount').html();
        }
        $('#contactsListShowing').html((self.currentPage + 1).toString());
        self.updateNumberCheckedMessage();
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.contactsCountFromServer = 0;

        // Remove all custom filters and add a blank one
        this.updatePagingUI();
    }

    private updateListName = (): void => {
        let title = $('[name="Title"]').val();
        let firtname = $('[name="FirstName"]').val();
        let surname = $('[name="Surname"]').val();

        let val = `${surname}, ${title} ${firtname}`;
        $('[name="ListName"]').val(val);
    }

    private deleteAccount = (cloudscribeID: string, modalEl: any): void => {
        //show the popup
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.ContactsDeleteCloudscribeUser }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete(){
            Utilities.BlockUI($('#contactsListResults'));
            $.post('/Contacts/DeleteCloudscribeUser', { cloudscribeID: cloudscribeID },
                function (result: IAPIResult) {
                    try {
                        if (result.success != null) {
                            toastr.info("Cloudscribe user deleted!");
                            modalEl.modal('hide');
                        }
                        else {
                            toastr.error('Failed to delete user!')
                        }
                    }
                    catch (err) {
                        console.log(err);
                        toastr.error('Failed to delete user!')
                        modalEl.modal('hide');
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    private deleteContact = (contactRef: string): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.ContactsDeleteCAMSUser }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            $.post('/Contacts/DeleteContact', { contactRef: contactRef },
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            toastr.info("Contact deleted!");
                            self.GetContactsData();
                            Utilities.GetModal('#contactsEditModal', ModalAction.Hide);
                            Utilities.GetModal('#contactsListModal', ModalAction.Show);
                        }
                        else {
                            toastr.error('Delete failed: the Contact cannot be deleted because it is linked to other records such as Issues, Consultations etc.')
                        }
                    }
                    catch (err) {
                        console.log(err);
                        toastr.error('Delete failed: the Contact cannot be deleted because it is linked to other records such as Issues, Consultations etc.')
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    private suggestListName = (surname: string, firstname: string, initials: string, company: string, town: string): string => {
        // Auto create the Listname as Surname + firstname or initials(if no firstname) + Company + Town (eg 'Pettitt AW, ESDM, Brecon')
        var listName = surname;
        if (firstname != "") listName += ` ${firstname}`;
        else if (initials != "") { listName += ` ${initials}`; }

        if (company != "") listName += `, ${company}`;
        if (town != "") listName += `, ${town}`;

        return listName;
    }
    
}




